import { customEvent } from "goi_common";

import { GOI_PHONE_HREF } from "@/constants/contact";
import { PhoneIcon } from "@/components/PhoneIcon";
import { ArrowRightIcon } from "@/components/DirectionsIcons";
import { toManwonRange } from "@/utils/formatMoney";

interface RegionFixedBarProps {
  sigunguName: string;
  familyCostMin: number | null;
  familyCostMax: number | null;
  href: string;
  /** 2026 추석. 장지, 화장장 포커스에서는 상담 전화를 빼고 비용 CTA만 남긴다. */
  hideCall?: boolean;
}

/**
 * 모바일 하단 고정 CTA. 전체 비용 섹션을 축약한 형태다.
 * CSS로 모바일에서만 노출한다(768px 이상에서는 본문 CTA가 계속 보인다).
 */
export const RegionFixedBar = ({
  sigunguName,
  familyCostMin,
  familyCostMax,
  href,
  hideCall = false,
}: RegionFixedBarProps) => {
  const range = toManwonRange(familyCostMin, familyCostMax);

  return (
    <div className="rg-fixedbar" role="region" aria-label="장례 비용 알아보기">
      <div className="rg-fixedbar__inner">
        {!hideCall && (
          <a
            className="rg-fixedbar__call"
            href={GOI_PHONE_HREF}
            aria-label="고이 24시간 무료 장례 상담"
            onClick={() =>
              customEvent({
                newGtm: {
                  path: "prlr_region",
                  trigger_and_target: "fixed_call",
                },
              })
            }
          >
            <PhoneIcon size={20} />
            <span>상담</span>
          </a>
        )}

        <a
          className="rg-fixedbar__cta"
          href={href}
          onClick={() =>
            customEvent({
              newGtm: { path: "prlr_region", trigger_and_target: "fixed_cost" },
            })
          }
        >
          <span className="rg-fixedbar__text">
            <span className="rg-fixedbar__title">
              {`${sigunguName} 장례 전체 비용 알아보기`}
            </span>
            {range && (
              <span className="rg-fixedbar__sub">{`시설 비용 ${range}`}</span>
            )}
          </span>
          <ArrowRightIcon size={18} />
        </a>
      </div>
    </div>
  );
};
